import Loading, { LoadingBall } from '@ingka/loading';
import Text from '@ingka/text';
import { useGetRetailUnitQuery } from '@lotta/self-service/lottery-fe/data-access-state';
import type { LocaleParams } from '@lotta/self-service/lottery-fe/types-router';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation, useNavigate, useParams } from 'react-router-dom';

/* eslint-disable-next-line */
export interface LocaleVerificationProps {}

export const LocaleVerification: React.FC<LocaleVerificationProps> = () => {
  const { countryCode, language } = useParams<LocaleParams>() as LocaleParams;
  const { data, isLoading } = useGetRetailUnitQuery({ retailUnit: countryCode });
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [isVerified, setIsVerified] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (!isLoading && data) {
      const { selfService } = data.retailUnit;
      if (selfService.languages.includes(language)) {
        setIsVerified(true);
      } else {
        const urlPrefix = pathname.split('/')[1];
        const urlSuffix = pathname.split('/').slice(3).join('/');
        const newPath = `/${urlPrefix}/${selfService.defaultLanguage}/${urlSuffix}`;
        navigate(newPath);
      }
    }
  }, [isLoading, data, language, pathname, navigate]);

  if (isLoading) {
    return (
      <Loading>
        <LoadingBall />
      </Loading>
    );
  }

  if (isVerified) {
    return <Outlet />;
  }

  // Else: something went wrong
  return <Text headingSize="m">{t('general-something-went-wrong')}</Text>;
};
